import { render, staticRenderFns } from "./CompanionSuccessPage.vue?vue&type=template&id=0ebe7bcf&scoped=true"
import script from "./CompanionSuccessPage.vue?vue&type=script&lang=js"
export * from "./CompanionSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./CompanionSuccessPage.vue?vue&type=style&index=0&id=0ebe7bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebe7bcf",
  null
  
)

export default component.exports